import { useAuth } from "../contexts/AuthContext";

/** Manager / sub-manager profile (assistance queue was removed; use inhouse panel for that workflow). */
const AdminProfile = () => {
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="admin-profile-container" style={{ padding: "2rem" }}>
        <p>No user data available</p>
      </div>
    );
  }

  return (
    <div className="admin-profile-container" style={{ padding: "2rem", maxWidth: 640 }}>
      <h2 style={{ marginBottom: "1rem" }}>Admin profile</h2>
      <p>
        <strong>Username:</strong> {user.username}
      </p>
      <p>
        <strong>Role:</strong> {user.role?.replace("_", " ")}
      </p>
    </div>
  );
};

export default AdminProfile;
